<template>
	<div class="register_container">
		<div class="img-form">
			<div class="avatar_box">
				<!--        <img src="../assets/images/login/bg.png" alt="">-->
				<div
					class="baImg bg-image"
					v-if="baImg && baImg.length > 0"
					:style="{ backgroundImage: 'url(' + baImg + ')' }"
				></div>

				<el-dropdown class="message-wrap" placement="bottom" :show-timeout="0">
					<div class="lang-trigger">
						<icon-font
							class="lang-icon"
							name="language1"
							:size="18"
						/>
						<span>{{ $t('_lang') }}</span>
						<i class="el-icon-arrow-down"></i>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(val, key) in i18nMessages" :key="key"
							@click.native="changeLang(key)">{{ val._lang }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<div class="footer-container">
					<!--        <div class="footer">千仓科技2供应链，专注中日国际物流</div>-->
					<!--        <div class="about">Copyright © www.zxwl.com, All Rights Reserved.</div>-->
				</div>
			</div>
			<div class="register_box">
				<!-- 表单 -->
				<div class="register_box_content">
					<div class="rText">{{ $t('loginR.login45') }}</div>
					<el-form ref="registerFormRef" :model="registerForm" label-width="0" :rules="registerFormRules"
						class="register_form" :disabled="termsUrl == '#'" label-position="top">
						<el-form-item prop="userName" :label="$t('loginR.login40')">
							<el-input v-model.trim="userName" :placeholder="$t('loginR.login36')" prefix-icon="el-icon-user"></el-input>
						</el-form-item>
						<el-form-item prop="realName" :label="$t('loginR.login41')">
							<el-input v-model.trim="registerForm.realName"
								:placeholder="$t('loginR.login37')" prefix-icon="el-icon-user"></el-input>
						</el-form-item>
						<el-form-item prop="emailAddress" :label="$t('loginR.login42')">
							<el-input v-model.trim="registerForm.emailAddress" type="email"
								:placeholder="$t('loginR.login9')">
								<icon-font
									slot="prefix"
									class="icon-font"
									name="email"
									:size="18"
								/>
							</el-input>
						</el-form-item>
						<!-- <el-form-item prop="mobileNumber">
            <el-input
            v-model="registerForm.mobileNumber"
            placeholder="请输入手机号码"></el-input>
          </el-form-item>-->
						<el-form-item prop="authCode" class="fu" :label="$t('loginR.login43')">
							<el-input
								v-model.trim="registerForm.authCode"
								:placeholder="$t('changeAccount.changeAccount13')"
								auto-complete="new-password"
							>
								<icon-font
									slot="prefix"
									class="icon-font"
									name="yanzhengma1"
									:size="18"
								/>
							</el-input>
							<el-link :underline="false" class="getVal" @click="getCode" :disabled="codeCountdown>0">{{
								codeCountdown>0 ? codeCountdown + 's' : $t('changeAccount.changeAccount14')
							}}</el-link>
						</el-form-item>
						<el-form-item prop="password" :label="$t('login.password')">
							<el-input v-model.trim="registerForm.password" :type="passwordVisible ? 'text' : 'password'" auto-complete="new-password"
								:placeholder="$t('login.login21')" prefix-icon="el-icon-lock">
								<icon-font
									slot="suffix"
									class="pwd-toggle"
									:name="passwordVisible ? 'view' : 'unview'"
									:size="16"
									@click="passwordVisible = !passwordVisible"
								/>
							</el-input>
						</el-form-item>
						<el-form-item prop="confirmPassword" :label="$t('loginR.login44')">
							<el-input v-model.trim="registerForm.confirmPassword" :type="confirmPasswordVisible ? 'text' : 'password'"
								:placeholder="$t('login.login22')" prefix-icon="el-icon-lock">
								<icon-font
									slot="suffix"
									class="pwd-toggle"
									:name="confirmPasswordVisible ? 'view' : 'unview'"
									:size="16"
									@click="confirmPasswordVisible = !confirmPasswordVisible"
								/>
							</el-input>
						</el-form-item>
						<el-form-item prop="isAgree">
							<div class="agree-item">
								<div class="flex-center">
									<el-checkbox v-model="checked" @change="onAgreeChange" />
									<el-link
										:href="termsUrl"
										class="agree-link"
										target="_blank"
										:disabled="termsUrl == '#'"
									>
										{{ $t('login.login24') }}
									</el-link>
									<span>{{ $t('login.login23') }}</span>
								</div>
								<div class="flex-center">
									<el-checkbox v-model="checked2" @change="onAgreeChange" />
									<el-link
										:href="privacyUrl"
										class="agree-link"
										target="_blank"
										:disabled="privacyUrl == '#'"
									>
										{{ $t('login.login36') }}
									</el-link>
									<span>{{ $t('login.login23') }}</span>
								</div>
							</div>
						</el-form-item>
						<el-form-item class="btnGo">
							<el-button class="btns" type="primary" @click="register"><span class="goText">{{
								$t('login.login25')
									}}</span></el-button>
						</el-form-item>
						<div class="registerText">
							<span>{{ $t('login.login41') }}</span>
							<el-link
								type="primary"
								:underline="false"
								class="agree-link"
								@click="login"
							>
								{{ $t('login.login2') }}
							</el-link>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { messages, setLang } from '@/i18n';
// import baImg from '../assets/images/login/bg3.png'

export default {
	data() {
		var validatePassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('loginR.login17')));
			} else if (value !== this.registerForm.password) {
				callback(new Error(this.$t('loginR.login18')));
			} else {
				callback();
			}
		};
		var validateIsAgree = (rule, value, callback) => {
			if (this.checked && this.checked2) {
				callback();
			} else if (!this.checked) {
				callback(new Error(this.$t('login.login27')));
			} else {
				callback(new Error(this.$t('login.login37')));
			}
		};
		var validateIsYs = validateIsAgree;
		return {
			i18nMessages: messages,
			checked: false,
			checked2: false,
			termsUrl: '#',
			privacyUrl: '#',
			registerForm: {
				userName: '',
				password: '',
				realName: '',
				confirmPassword: '',
				mobileNumber: '',
				emailAddress: '',
				authCode: ''
			},
			// 获取验证码倒计时相关数据
			codeCountdown: 0, // 剩余秒数
			codeTimer: null, // 定时器句柄
			passwordVisible: false,
			confirmPasswordVisible: false,
			registerFormRules: {
				userName: [
					{ required: true, message: this.$t('login.login3'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							var reg = /^(?![0-9]+$)(?![a-z]+$)[0-9a-z]{6,20}$/; //6-20位小写字母和数字
							var reg1 = /^[0-9]{6,20}$/; //6-20位数字
							var reg2 = /^[a-z]{6,20}$/; //6-20位小写字母
							var reg3 = /^[A-Z]{6,20}$/; //6-20位大写字母
							if (reg.test(value) || reg1.test(value) || reg2.test(value) || reg3.test(value)) {
								callback();
							} else {
								callback(new Error(this.$t('login.login28')));
							}
						},
						trigger: 'blur'
					}
				],
				password: [
					{ required: true, message: this.$t('loginR.login16'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							// var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,16}$/; //6-20位小写字母和数字
							var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/; //6-20位小写字母和数字
							if (reg.test(value)) {
								callback();
							} else {
								callback(new Error(this.$t('login.login38')));
							}
						},
						trigger: 'blur'
					}
				],
				mobileNumber: [
					{ required: true, message: this.$t('login.login30'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							const regMobile = /^[1][3,4,5,7,8][0-9]{9}$/;
							if (regMobile.test(value)) {
								callback();
							}
							callback(new Error(this.$t('login.login31')));
						},
						trigger: 'blur'
					}
				],
				emailAddress: [
					{ required: true, message: this.$t('loginR.login9'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							const regMobile = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/i;
							if (regMobile.test(value)) {
								callback();
							}
							callback(new Error(this.$t('login.login31')));
						},
						trigger: 'blur'
					}
				],
				confirmPassword: [
					{ required: true, message: this.$t('login.login32'), trigger: 'blur' },
					{ validator: validatePassword, trigger: 'blur', required: true }
				],
				authCode: [
					{ required: true, message: this.$t('changeAccount.changeAccount13'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							var reg = /^[0-9]{4}$/; //6-20位小写字母和数字
							if (reg.test(value)) {
								callback();
							} else {
								callback(new Error(this.$t('login.login29')));
							}
						},
						trigger: 'blur'
					}
				],
				realName: [
					{ required: true, message: this.$t('loginR.login37'), trigger: 'blur' },
					{ max: 50, trigger: 'blur' }
				],
				isAgree: [
					//{required:true,message:'请同意《用户协议》',trigger:'change'},
					{ validator: validateIsAgree, trigger: 'change', required: true }
				],
				isYs: [
					//{required:true,message:'请同意《用户协议》',trigger:'change'},
					{ validator: validateIsYs, trigger: 'change', required: true }
				]
			},
      baImg: ''
		};
	},
	created() {
		// this.loadProtocolLinks()
	},
	computed: {
		userName: {
			get: function () {
				return this.registerForm.userName;
			},
			set: function (val) {
				this.registerForm.userName = val.toLowerCase();
			}
		}
	},
	methods: {
		changeLang(key) {
			this.$i18n.locale = key;
			setLang(key);
		},
		onAgreeChange() {
			this.$nextTick(() => {
				this.$refs.registerFormRef && this.$refs.registerFormRef.validateField('isAgree');
			});
		},
		login() {
			window.sessionStorage.clear;
			this.$router.push({
				name: 'login'
			});
		},
		resetregisterForm() {
			this.$refs.registerFormRef.resetFields();
		},
		register() {
			if(this.termsUrl == '#' || this.privacyUrl == '#'){
				this.$message({
					message: this.$t('loginR.login39'),
					type: 'error'
				});
				return
			}
			this.$refs['registerFormRef'].validate(async (valid) => {
				if (valid) {
					const { data: res } = await this.$http.post('admin/register', this.registerForm);
					if (res.code == 200) {
						this.$message({
							message: this.$t('login.login33'),
							type: 'success'
						});
						this.$router.push({
							name: 'login'
						});
					} else {
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				} else {
					// this.$message({
					// 	message: this.$t('login.login34'),
					// 	type: 'error'
					// });
				}
			});
		},
		async loadProtocolLinks() {
			try {
				const res = await this.$http.get('basicInfoConfig/getSomeConfig', { params: { type: [1, 2] }, headers: { noLoading: true } })
				if(res?.data?.data?.userServiceAggreement == null || res?.data?.data?.privacyPolicy == null){
					this.termsUrl = '#'
					this.privacyUrl = '#'
					this.$message({
					message: this.$t('loginR.login39'),
						type: 'error'
					});
					return
				}

				let termsUrl = process.env.VUE_APP_BASE_DOMAIN + res?.data?.data?.userServiceAggreement
				let privacyUrl = process.env.VUE_APP_BASE_DOMAIN + res?.data?.data?.privacyPolicy

        this.termsUrl = window.location.origin + '/pdfjs/web/viewer.html?file=' +  termsUrl
        this.privacyUrl = window.location.origin + '/pdfjs/web/viewer.html?file=' + privacyUrl

			} catch (e) {
				this.termsUrl = '#'
				this.privacyUrl = '#'
			}
		},
    openOne(){
      window.open(this.termsUrl, '_blank')
    },
    openTwo(){
      window.open(this.privacyUrl, '_blank')
    },
		async getCode() {
			// 若倒计时进行中，直接返回，避免重复点击
			if (this.codeCountdown > 0) return;
			var url = 'admin/sendVerificationCode';
			const { data: res } = await this.$http.get(url, {
				params: {
					email: this.registerForm.emailAddress,
					smsType: '0'
				}
			});
			console.log(res.code);
			if (res.code == 200) {
				this.$message({
					message: this.$t('changeAccount.changeAccount16'),
					type: 'success'
				});
				// 开始60秒倒计时
				this.startCodeCountdown();
			} else {
				console.log(this.registerForm.emailAddress);
				this.$message({
					message: res.message,
					type: 'error'
				});
			}
		},
		// 开始获取验证码倒计时
		startCodeCountdown() {
			// 清理可能存在的定时器
			if (this.codeTimer) {
				clearInterval(this.codeTimer);
				this.codeTimer = null;
			}
			this.codeCountdown = 60;
			this.codeTimer = setInterval(() => {
				if (this.codeCountdown > 0) {
					this.codeCountdown -= 1;
				} else {
					clearInterval(this.codeTimer);
					this.codeTimer = null;
				}
			}, 1000);
		},
		toLowerCase(value) {
			if (value) {
				value = value.toLowerCase();
			}
		}
	},
  watch: {
    '$store.state.tenantConfig': {
      handler(newVal) {
        if (newVal && newVal.tenant) {
			this.baImg = newVal.baImg
          	this.loadProtocolLinks();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
	margin-bottom: 30px !important;
}

.register_container {
	height: 100%;
	width: 100%;
	// background: url("../assets/images/login/bg.png") no-repeat;
	background-size: cover;
}

//.register_box{
//  position: relative;
//}
.registerText {
	position: relative;
	bottom: 7%;
	margin-left: 59px;
}

.register_box_content {
	//padding: 15%;
	//padding-top: 30%;
	padding: 30px;
	background-color: #fff;
	border-radius: 16px;
	box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.img-form {
	overflow: hidden;
	height: 100%;

	.avatar_box {
		position: relative;
		float: left;
		width: 100%;
		height: 100%;

		.bg-image {
			width: 100%;
			height: 100%;
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-position: center center;
		}

		.message-wrap {
			position: absolute;
			top: 30px;
			right: 30px;
		}
	}

	.register_box {
		position: absolute;
		// left: 208px;
		top: 50%;
		transform: translateY(-50%);
		width: 37.5%;
		min-width: 552px;
		display: flex;
    	justify-content: center;
	}
}

.register_form {
	bottom: 0;
	width: 100%;
	padding: 0px;
	box-sizing: border-box;
}

.footer-container {
	width: 100%;
	position: absolute;
	bottom: 10%;
	text-align: center;
}

.footer {
	font-size: 30px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	letter-spacing: 4px;
	color: #fefeff;
}

.about {
	font-size: 16px;
	font-family: Source Han Sans CN;
	// font-weight: 400;
	color: #fefeff;
	padding-top: 10px;
}

.getVal {
	position: absolute;
	margin-top: 10px;
	//width: 112px;
	height: 18px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1373fb;
	line-height: 40px;
	//margin-left: 10px;
	right: 17px;
}

.rText {
	//width: 200px;
	height: 46px;
	font-size: 48px;
	font-family: Lantinghei SC;
	font-weight: 600;
	color: #3a4255;
	text-shadow: 0px 3px 3px rgba(34, 40, 66, 0.43);
	margin-bottom: 50px;
}

/deep/ .el-input__inner {
	border: none !important;
	border-bottom: 1px solid #606266 !important;
	width: 415px;
  border-radius: 0;
}

/deep/ .el-input--prefix .el-input__inner {
	padding-left: 40px !important;
}

.fu {
	position: relative;
}

.ml-55 {
	margin-left: 115px !important;
}

.registerText {
	position: static;
	bottom: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;

	.agree-link {
		margin-left: 8px;
	}
}

.img-form {
	position: relative;

	.avatar_box {
		img {
			object-fit: cover;
		}

		.message-wrap {
			z-index: 10;
		}

		.lang-trigger {
			min-width: 108px;
			height: 38px;
			padding: 0 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
			background: rgba(255, 255, 255, 0.95);
			border: 1px solid #e5e8ef;
			border-radius: 6px;
			box-shadow: 0 8px 24px rgba(29, 55, 93, 0.08);
			color: #2f3a4f;
			font-size: 15px;
			font-weight: 500;
			line-height: 1;
			gap: 8px;
			cursor: pointer;
			user-select: none;
			transition: border-color 0.2s, box-shadow 0.2s;

			&:hover {
				border-color: #c8d5ee;
				box-shadow: 0 10px 28px rgba(29, 55, 93, 0.12);
			}

			.lang-icon {
				color: #2f3a4f;
				flex: none;
			}

			.el-icon-arrow-down {
				color: #6f7f96;
				font-size: 13px;
				font-weight: 600;
				flex: none;
			}
		}
	}
}

.register_form {
	/deep/ .el-form-item {
		margin-bottom: 16px !important;
	}

	/deep/ .el-form-item__label {
		line-height: normal;
		padding: 0 0 5px;
		color: #363c5a;
		font-size: 14px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
		display: none;
	}

	/deep/ .el-input__inner {
		width: 100%;
		height: 44px;
		line-height: 44px;
		background-color: #fff !important;
		border: 1px solid #eaebef !important;
		border-radius: 8px !important;
		color: #303133;
		padding-left: 42px !important;
		padding-right: 36px !important;
		font-size: 14px;
	}

	/deep/ .el-input__inner::placeholder {
		color: #b6b9c4;
	}

	/deep/ .el-input__prefix {
		left: 14px;
		display: flex;
		align-items: center;
		color: #363c5a !important;
	}

	/deep/ .el-input__suffix {
		right: 12px;
		display: flex;
		align-items: center;
		cursor: pointer;
		color: #363c5a !important;
	}

	/deep/ .el-input__prefix .el-input__icon {
		line-height: 44px;
		font-size: 18px;
		color: #363c5a;
	}

	.icon-font {
		width: 25px;
	}

	.pwd-toggle {
		fill: currentColor;
		flex: none;
	}

	/deep/ .el-checkbox__inner {
		width: 12px;
		height: 12px;
		border-color: #363c5a;

		&:hover {
			border-color: #4b70f1;
		}

		&::after {
			left: 3px;
			top: 0;
		}
	}

	/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
		border-color: #4b70f1;
		background-color: #4b70f1;
	}

	/deep/ .el-checkbox {
		margin-right: 4px;
	}

	/deep/ .el-form-item__error {
		font-size: 10px;
		padding-top: 2px;
	}

	.agree-item {
		display: flex;
		justify-content: space-between;
		line-height: normal;

		.flex-center {
			display: flex;
			align-items: center;
		}

		.agree-link {
			color: #4b70f1;
			text-decoration: underline;
		}
	}

	.fu {
		/deep/ .el-form-item__content {
			display: flex;
			line-height: normal;
		}

		/deep/ .el-input {
			flex: 1;
			line-height: 44px;
		}

		.getVal {
			position: static;
			height: auto;
			margin: 0 0 0 12px;
			padding: 8px;
			border: 1px solid #4b70f1;
			border-radius: 8px;
			background: #f6fafe;
			color: #4b70f1;
			font-size: 14px;
			line-height: 1.4;
			white-space: nowrap;
		}
	}

	.registerText {
		/deep/ .el-link.el-link--primary {
			color: #4b70f1;
		}
	}
}

.btnGo {
	position: static;
	top: auto;
	margin-left: 0;
}

.btns {
	width: 100%;
	height: 44px;
	line-height: 44px;
	padding-top: 0;
	margin-top: 0;
	background: #446de3;
	border: none;
	border-radius: 8px;
	color: #ffffff;
}

.btns span {
	font-size: 17px !important;
}

.rText {
	height: auto;
	font-size: 36px;
	font-family: Lantinghei SC;
	font-weight: 600;
	margin-bottom: 30px;
	text-align: center;
	color: #3a4255;
	text-shadow: none;
}
@media screen and (max-height: 850px) {
	.img-form {
		.register_box {
			transform: translateY(-50%) scale(0.8);
		}
	}
    
}
</style>
